/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

const mutations = {

  setAmountNeesToDo(state, amount) {
    state.requestNeedToDo = amount;
  },
  setAmountMyCreate(state, amount) {
    state.requestMyCreate = amount;
  },
  setAmountMyExecute(state, amount) {
    state.requestMyExecute = amount;
  },

  toggleReduceButton(state, val) {
    state.reduceButton = val;
  },

  updateWindowBreakpoint(state, val) {
    state.breakpoint = val;
  },
  updatePrimaryColor(state, val) {
    state.themePrimaryColor = val;
  },

  updateUserInfo(state, userInfor) {
    state.userInfor = userInfor;
  },
  // set giá trị cho cơ cấu tổ chức
  setDataJobPosition(state, dataJobPosition) {
    state.dataJobPosition = dataJobPosition;
  },
  // set giá trị cho cơ cấu tổ chức
  setDataOrganization(state, dataOrganization) {
    state.dataOrganization = dataOrganization;
  },
  // set giá trị cho cơ cấu tổ chức
  setDataOrganizationCommon(state, dataOrganizationCommon) {
    state.dataOrganizationCommon = dataOrganizationCommon;
  },
  // set giá trị cho cơ cấu tổ chức chứa đơn vị ngưng hoạt động
  setDataOrganizationCommonInactive(state, dataOrganizationCommonInactive) {
    state.dataOrganizationCommonInactive = dataOrganizationCommonInactive;
  },
  setSelectedCount(state, selectedCount) {
    state.selectedCount = selectedCount;
  },
  setEditingMode(state, isEditingMode) {
    state.isEditingMode = isEditingMode;
  },
  // Lưu danh sách quyền người dùng
  setListRole(state, listRole) {
    state.listRole = listRole;
  },
  // Lấy ra danh sách trạng thái mở cây của tree list
  setExpandedTreeList(state, expandedTreeList) {
    state.expandedTreeList = expandedTreeList;
  },
  // Lưu danh sách cột các màn hình grid
  setGridConfig(state, gridConfig) {
    state.gridConfig = gridConfig;
  },
  // Lưu danh sách cột các màn hình grid
  setUserOptions(state, userOptions) {
    state.userOptions = userOptions;
  },
  setLstReportMaster(state, lstReportMaster) {
    state.lstReportMaster = lstReportMaster;
  },
  setStateLoadListProcess(state, stateLoadListProcess) {
    state.stateLoadListProcess = stateLoadListProcess;
  },
  setExecutorFirstStep(state, executorFirstStep) {
    state.executorFirstStep = executorFirstStep;
  },

  //Cập nhật trạng thái có cho phép sửa dữ liệu hay không
  updateStateEditable(state, isEditable) {
    state.isEditable = isEditable;
  },
  setActiveMenu(state, activeMenu) {
    state.activeMenu = activeMenu;
  },
  // Set giá trị vào companyConflicts
  setCompanyConflicts(state, conflicts) {
    state.companyConflicts = conflicts;
  },
  clearCompanyConflicts(state) {
    state.companyConflicts = []; // Xóa dữ liệu bằng cách gán mảng rỗng
  },
  // Set giá trị vào companyList
  setCompanyList(state, lists) {
    state.companyList = lists;
  },
  clearCompanyList(state) {
    state.companyList = []; // Xóa dữ liệu bằng cách gán mảng rỗng
  },
  // Set giá trị vào companyList
  setCompanyInfos(state, lists) {
    state.companyInfos = lists;
  },
  clearCompanyInfos(state) {
    state.companyInfos = []; // Xóa dữ liệu bằng cách gán mảng rỗng
  },
};

export default mutations;